// src/store/useExerciseStore.ts
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface ExerciseData {
  exerciseFileName: string;
  level: string;
  topic: string;
  difficulty: string;
}

interface AdminState {
  newExercise: ExerciseData | null;
  setExerciseData: (data: ExerciseData) => void;
  clearExerciseData: () => void;
}

export const useAdminUserStore = create(
  persist<AdminState>(
    (set) => ({
      newExercise: null,

      setExerciseData: (data) => set({ newExercise: data }),
      clearExerciseData: () => set({ newExercise: null }),
    }),
    {
      name: "shooinit-admin-users",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
